import React, { Component } from 'react';
import CustomerFullDetails from './customer-full-details.jsx';
import CustomerJobsAwaitingInvoice from './customer-jobs-awaiting-invoice.jsx';
import { Animate } from 'react-simple-animate';
export default class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFullCustomerDetails: false,
      showCustomerJobsAwaitingInvoice: false,
      data: this.props.data || null,
      play: false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data
      });
    }
  }
  componentDidMount() {
    this.setState({
      play: true
    });
  }
  handleFullCustomerDetailsButtonClick() {
    this.setState({
      showFullCustomerDetails: !this.state.showFullCustomerDetails,
      showCustomerJobsAwaitingInvoice: false,
    });
  }
  handleCustomerJobsAwaitingInvoiceButtonClick() {
    this.setState({
      showCustomerJobsAwaitingInvoice: !this.state.showCustomerJobsAwaitingInvoice,
      showFullCustomerDetails: false,
    });
  }
  render() {
    return(
      <div
      className={"customers-table-customer-row"+(
        (!this.state.data.jobs || this.state.data.jobs.length === 0)?
        ' no-jobs-awaiting-invoice ':''
      )+(
        (this.state.showCustomerJobsAwaitingInvoice ||
         this.state.showFullCustomerDetails)?
        ' customer-row-opened ':''
      )}
      id={"customer-row-"+this.state.data.id}>
        <div className={"row customer-row-header"+
          ((this.state.showCustomerJobsAwaitingInvoice === true)?
           ' dark-mode ' : ''
        )+((this.state.showFullCustomerDetails === true) ?
          ' green-mode ' : ''
          )
        }>
          <div className="col-md-3">
            <strong>{this.state.data.name}</strong>
            <small>{this.state.data.contact_name}</small>
          </div>
          <div className="col-md-3">
            <button
              className="btn btn-light btn-sm"
              onClick={() => {
                this.handleCustomerJobsAwaitingInvoiceButtonClick()
              }
            }>
            jobs awaiting invoice&nbsp;&nbsp;
            <i
              className={
                "fa "+
                (
                  this.state.showCustomerJobsAwaitingInvoice ?
                  " fa-times " :
                  " fa-level-down-alt "
                )
              }
              id={
                "fa-customer-jobs-awaiting-invoice-icon-"+
                this.state.data.id
              }
            >
            </i>
            </button> <div
            className={"customer-jobs-awaiting-invoice-count"+(
              ((this.state.data.jobs !== null) &&
              this.state.data.jobs.length > 0) ? ' red ' : ' green '
            )}
            >
            {this.state.data.jobs !== null ? this.state.data.jobs.length : '0'}
            </div>
          </div>
          <div className="col-md-2">
          <a className="btn btn-light btn-sm"
             href={"/jobs/customer/"+this.state.data.id+"/invoiced"}>
             <i className="fa fa-road"></i> Invoiced Jobs <i
             className="fa fa-arrow-right"></i>
          </a>
          </div>
          <div className="col-md-2">
            <button
              className="btn btn-light btn-sm"
              onClick={() => {
                this.handleFullCustomerDetailsButtonClick()
              }}
            >
            settings and info&nbsp;
            <i className={"fa "+(
              this.state.showFullCustomerDetails ?
              " fa-times " :
              " fa-level-down-alt "
            )}
               id={"fa-full-details-icon-"+this.state.data.id}></i>
            </button>
          </div>
          <div className="col-md-2">
            <a className="btn btn-light btn-sm"
               href={"/jobs/customer/"+this.state.data.id}>
               <i className="fa fa-road"></i> All Jobs <i
               className="fa fa-arrow-right"></i>
            </a>
          </div>
        </div>
        {
          this.state.showFullCustomerDetails ?
            <Animate
              play={this.state.play}
              start={{opacity: 0}}
              end={{opacity:1}}
            >
              <CustomerFullDetails
                key={'customer-'+this.state.data.id+'-fd'}
                data={this.state.data}
              />
            </Animate>
          :  ''
        }
        {
          this.state.showCustomerJobsAwaitingInvoice ?
            <Animate
              play={this.state.play}
              start={{opacity: 0}}
              end={{opacity:1}}
            >
              <CustomerJobsAwaitingInvoice
                key={'customer-'+this.state.data.id+'-jobs-awaiting-invoice'}
                data={this.state.data}
              />
            </Animate>
          : ''
        }
      </div>
    );
  }
}
